import { styled, Dialog, Box, Button } from '@mui/material';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    maxWidth: '800px',
    borderRadius: 16,
    backgroundColor: '#FAFCFF',
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: 700,
  minHeight: 200,
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
}));

export const ConfirmationContainer = styled(Box)(() => ({
  minWidth: 500,
  minHeight: 200,
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ChargeBackButton = styled(Button)(() => ({
  display: 'flex',
  gap: 8,
  width: '100%',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '200px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  textTransform: 'lowercase',
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  maxWidth: '200px',
  backgroundColor: theme.palette.secondary.main,
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  gap: '40px',
  justifyContent: 'center',
  marginTop: 34,
}));
